// extracted by mini-css-extract-plugin
export var dropdownContainer = "_6x-5";
export var imageContainer = "_6x-4";
export var metricsGrid = "_6x-2";
export var productDetailContainer = "_6x-1";
export var productListContainer = "_6x-0";
export var subscriberTableContainer = "_6x-3";